export default {
  key: "cp_sessions_all",
  id: "session_id",
  export: ["excel"],
  excel: {
    //max_row: "50000" 
  },
  sort: {
    field: "session_id",
    order: "desc"
  },
  sort_fields: [
    "session_id",
    "cp_no",
    "total_charge_time",
    "total_pw_consume",
    "running_pw_consume",
    "session_start_time",
    "session_end_time",
    "cre_dttm"
  ],
  options: {
    cp_no: {
      key: "cps",
      label: "cp_no",
      value: "cp_no",
    },
    account_id: {
      key: "accounts",
      label: "first_name",
      value: "acc_id"
    }
  },
  filters: {
    cp_id: {},
    session_id: {},
    cp_no: {
      type: "multiselect",
      filterable: true
    },
    cp_name: {},
    session_start_time: {
      type: "daterange"
    },
    session_end_time: {
      type: "daterange"
    },
    cre_dttm: {
      type: "daterange"
    },
    account_id: {
      type: "select",
    }
  },
  action: ["pop-view"],
  fields: [
    { key: "session_id", width: 100 },
    { key: "account_id", field: "account_id.car_reg_no" },
    { key: "id_tag" },
    { key: "cp_no", field: "cp_id.cp_no" },
    { key: "cp_name", field: "cp_id.name" },
    // { key: "charge_box_serial_number", field: "cp_id.charge_box_serial_number", width: 90 },
    { key: "connector_id", field: "connector_id" },
    { key: "total_charge_time", type: "s_to_hms"},
    { key: "total_pw_consume", type: "float", decimal_point: 3 },
    { key: "running_pw_consume", type: "float", decimal_point: 3 },
    { key: "session_start_time", type: "datetime" },
    { key: "start_meter", type: "float", decimal_point: 3 },
    { key: "session_end_time", type: "datetime", fill: false },
    // { key: "end_meter", type: "float", decimal_point: 3 },
    // { key: "cre_dttm", type: "datetime" },
    { key: "start_soc" },
    { key: "end_soc" },
    { type: "action-btn", width: 50 },
    // { key: "external_account_id"}
  ],
  view: {
    api: "cp_requests",
    id: "session_id",
    key: "cp_session_detail",
    sort: {
      field: "req_id",
      order: "desc"
    },
    params: {
      type: "MeterValues",
      size: "50000",
      order: "asc"
    },
    fields: [
      { key: "cre_dttm", type: "datetime" },
      { key: "energy", type: "meter_value", unit: "Wh"  },
      { key: "voltage", type: "meter_value", unit: "V"  },
      { key: "ampere", type: "meter_value", unit: "A"  },
    ],
    extra_fields: [
      { key: "cp_no", field: "cp_id.cp_no"},
      { key: "connector_id", field: "connector_id" },
      { key: "session_start_time", type: "datetime" },
      { key: "session_end_time", type: "datetime", fill: true },
      { key: "total_charge_time", type: "s_to_hms", width: 100 },
    ]
  }
}